import { useQuery, UseQueryResult } from "@tanstack/react-query";
import MyEmoryContact from "../../../../../../models/salesforce/MyEmoryContact";
import { EUFinanceReactQueryKey } from "../../../../models/EUFinanceReactQueryKey";
import { useEUFinanceContactService } from "../../../../services/EUFinanceContactService";

export type UseEUFinanceCurrentUserResult = UseQueryResult<MyEmoryContact>;

const useEUFinanceCurrentUser = (): UseEUFinanceCurrentUserResult => {
  const contactService = useEUFinanceContactService();

  return useQuery<MyEmoryContact>({
    queryKey: EUFinanceReactQueryKey.GET_ME,
    queryFn: () => contactService.getMe(),
  });
};

export default useEUFinanceCurrentUser;
